import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";
import { getTranslatedText as translate } from "../../Localization/Translation";

const useFavWasher = () => {
  const { locale, setSelectedLaundryIndex } = useBetween(
    useSelector((state) => state.useSharedState)
  );
  const Launds = useSelector((state) => state.AllLaunds);
  const [show, setShow] = useState(false);

  let d = "-1";
  var LaundCards = Launds.map((Laund, index) => {
    d = Number(d) + 1;
    if (Laund.fav)
      return (
        <div
          className={
            "Laund-item-list col-1 animate__animated animate__fadeInLeft animate__delay-" +
            d +
            "s"
          }
          key={Laund.id}
          onClick={() => handleShow(index)}
        >
          <div className=" Laund-item-card-list">
            <div className="card border-radius">
              <div
                className="card-body card-body-laund"
                dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
              >
                <div dir={locale === "EN" || locale === "HN" ? "rtl" : "ltr"}>
                  {Laund.freeDelivery || Laund.discount ? (
                    <div className="card-offer">
                      {Laund.freeDelivery ? (
                        <span>
                          <i className="bi bi-truck"></i>
                          <span>{translate("free-deliver-label", locale)}</span>
                        </span>
                      ) : (
                        ""
                      )}
                      {Laund.freeDelivery && Laund.discount ? " + " : ""}
                      {Laund.discount ? (
                        <span>
                          <span>{translate("discount-label", locale)}</span>{" "}
                          <span>(50%)</span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="card-padding">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="card-title-laund">
                      <h5 className="card-title card-title-laund">
                        {Laund.name}
                      </h5>
                      <p className="card-text card-fav-icon">
                        <i className="bi bi-heart-fill like-icon-rate"></i>
                      </p>
                    </div>
                    <div className="card-title-laund">
                      <p className="card-text card-star-icon">
                        <span>{Laund.rate}</span>
                        <i className="bi bi-star-fill star-icon-rate"></i>
                      </p>
                    </div>
                  </div>
                  <hr />
                  <p
                    className="card-text card-text-laund"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title={Laund.locate}
                  >
                    <span>
                      {translate("laundry-location-label-card", locale)}
                    </span>
                    {Laund.locate.slice(0, 50)}
                    {Laund.locate.length > 50 ? "..." : ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    else return <></>;
  });

  const handleShow = (laundryIndex) => {
    setSelectedLaundryIndex(laundryIndex);
    setShow(true);
  };
  const handleClose = () => setShow(false);

  return {
    locale,
    show,
    LaundCards,
    handleClose,
  };
};

export default useFavWasher;
